import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ViewOnboarding from 'components/views/user/onboarding/companies/component';
import ViewWrapper from 'components/views/user/root/component';
import ViewOnboardingPlayersNew from 'components/views/user/onboarding/players/component';
export var WrapperRouter = function () {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/onboarding/players/:companyId", element: React.createElement(ViewOnboardingPlayersNew, null) }),
        React.createElement(Route, { path: "/onboarding/players", element: React.createElement(ViewOnboardingPlayersNew, null) }),
        React.createElement(Route, { path: "/onboarding/:tokenId", element: React.createElement(ViewOnboarding, null) }),
        React.createElement(Route, { path: "/onboarding", element: React.createElement(ViewOnboarding, null) }),
        React.createElement(Route, { path: "/*", element: React.createElement(ViewWrapper, null) })));
};
